import { render, staticRenderFns } from "./SupplierHeader.vue?vue&type=template&id=4a4ea1e8&scoped=true&"
import script from "./SupplierHeader.vue?vue&type=script&lang=js&"
export * from "./SupplierHeader.vue?vue&type=script&lang=js&"
import style0 from "./SupplierHeader.vue?vue&type=style&index=0&id=4a4ea1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ea1e8",
  null
  
)

export default component.exports